import 'react-responsive-modal/styles.css';
import React from 'react';
import { BrowserRouter as Router, Route, Switch, Redirect } from 'react-router-dom';
import { ClipLoader } from 'react-spinners';
import { QueryClient, QueryClientProvider } from 'react-query';
import history from './utils/history';
import config from './config';
import PrivateRoute from './utils/privateRoute';
import routeList from './router';
import NavigationProvider from './components/NavigationProvider';
import { AuthProvider } from './components/providers/AuthProvider';
import NavChild from './components/navChild';

const queryClient = new QueryClient();

function App() {
  return (
    <>
      <QueryClientProvider client={queryClient}>
        <AuthProvider>
          <Router basename="/" history={history} config={config}>
            <NavigationProvider>
              <React.Suspense fallback={<ClipLoader label="Fetching Your Page" loading color="#333869" />}>
                <div className="flex w-screen">
                  <div className={process.env.NODE_ENV === 'staging' ? 'navigation-staging-change navigation-container' : 'navigation-container'}>
                    <NavChild />
                  </div>
                  <div className="kaas-main-div main w-auto pl-4">
                    <Switch>
                      {routeList.secureRoutes.map((route) => {
                        const { key, path, component, ...rest } = route;
                        return (
                          <PrivateRoute
                            exact
                            key={key}
                            path={path}
                            component={component}
                            settings={rest}
                          />
                        );
                      })}
                      <Redirect from="/" to="/dashboard" exact />
                      {routeList.publicRoutes.map((route) => (
                        <Route
                          exact
                          key={route.key}
                          path={route.path}
                          component={route.component}
                        />
                      ))}
                    </Switch>
                  </div>
                </div>
              </React.Suspense>
            </NavigationProvider>
          </Router>
        </AuthProvider>
      </QueryClientProvider>
    </>
  );
}
export default App;
